// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-pending-deposit-modal-modal_card-ya63v {
  width: 344px;
  height: auto;
  max-height: 640px;  
}

.register-pending-deposit-modal-modal_content-P7MCd {
  padding: 0px 20px;
}

.register-pending-deposit-modal-selectTitle-lRlzJ, .register-pending-deposit-modal-transactionTitle-C1wFQ {
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.75);
}

.register-pending-deposit-modal-selectTitle-lRlzJ {
  margin: 20px 0px;
}

.register-pending-deposit-modal-transactionTitle-C1wFQ {
  margin: 24px 0px 10px;
}

.register-pending-deposit-modal-detailItem_container-rllFu {
  width: auto;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 16px;
  padding: 18px 0px;
  margin: 0px 1px;
}

.register-pending-deposit-modal-detailItem_title-myU4q {
  font-size: 15px;
  font-weight: normal;
}

.register-pending-deposit-modal-detailItem_text-uaubg {
  font-weight: 500;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.75);
}

.register-pending-deposit-modal-detailItem_green-nUjrZ {
  color: var(--money-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/bank-account/pending-transactions/register-pending-deposit-modal/register-pending-deposit-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".modal_card {\n  width: 344px;\n  height: auto;\n  max-height: 640px;  \n}\n\n.modal_content {\n  padding: 0px 20px;\n}\n\n.selectTitle, .transactionTitle {\n  display: block;\n  font-size: 15px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.selectTitle {\n  margin: 20px 0px;\n}\n\n.transactionTitle {\n  margin: 24px 0px 10px;\n}\n\n.detailItem_container {\n  width: auto;\n  flex-wrap: wrap;\n  row-gap: 12px;\n  column-gap: 16px;\n  padding: 18px 0px;\n  margin: 0px 1px;\n}\n\n.detailItem_title {\n  font-size: 15px;\n  font-weight: normal;\n}\n\n.detailItem_text {\n  font-weight: 500;\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.detailItem_green {\n  color: var(--money-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `register-pending-deposit-modal-modal_card-ya63v`,
	"modal_content": `register-pending-deposit-modal-modal_content-P7MCd`,
	"selectTitle": `register-pending-deposit-modal-selectTitle-lRlzJ`,
	"transactionTitle": `register-pending-deposit-modal-transactionTitle-C1wFQ`,
	"detailItem_container": `register-pending-deposit-modal-detailItem_container-rllFu`,
	"detailItem_title": `register-pending-deposit-modal-detailItem_title-myU4q`,
	"detailItem_text": `register-pending-deposit-modal-detailItem_text-uaubg`,
	"detailItem_green": `register-pending-deposit-modal-detailItem_green-nUjrZ`
};
export default ___CSS_LOADER_EXPORT___;
